module.exports = __webpack_public_path__ + "static/img/Engangspall.8f3f982.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Engangspall.jpg
// module id = KuQ6
// module chunks = 1